import { useContext } from 'react';
import { VolunteerAuthContext } from '../contexts/VolunteerAuthContext';

export function useVolunteerAuth() {
  return useContext(VolunteerAuthContext);
}
